<div [formGroup]="learningCenterForm" id="research-section-input-container" class="card p-4">
  <h3 style="font-weight: 700; color:#060E9F">งานวิจัยที่เกี่ยวข้อง<lifedi-require></lifedi-require></h3>
  <nz-form-item>
    <nz-form-control nzErrorTip="โปรดระบุ" [nzSpan]="24">
      <div
      [ngClass]="{
        error:
        RESEARCH_TEXT.invalid &&
        RESEARCH_TEXT.dirty
      }"
    >
      <angular-editor id="reseach-text-editor" placeholder="ระบุงานวิจัยที่เกี่ยวข้อง"
      style="margin: 0 auto;" [config]="editorConfig" formControlName="RESEARCH_TEXT">
    </angular-editor>
  </div>
    </nz-form-control>
  </nz-form-item>
</div>
